import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { LoaderService } from '@shared/services/loader.service';

@Component({
  standalone: true,
  selector: 'app-loader',
  imports: [],
  template: `
    @if(loaderService.isLoading()) {
      <div class="overlay">
        <div class="new-spinner gradient-bars">
          <div></div><div></div><div></div><div></div>
          <div></div><div></div><div></div><div></div>
        </div>
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
  protected loaderService = inject(LoaderService);
}
